import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const ViewModal = ({ show, handleClose }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">View Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Render row details */}
                    <div class="row">
                        <div class="col-md-12 mb-2">
                            <span style={{fontWeight: 'bold'}}>Template Name</span>
                            <p>Notification Email</p>
                        </div>
                        <div class="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Subject</span>
                            <p>Xyz</p>
                        </div>
                        <div class="col-md-12 mb-2">
                            <span style={{fontWeight: 'bold'}}>Body:</span>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing
                                elit. Accusamus recusandae fugiat sit quas in amet dignissimos illum aliquid </p>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewModal;